import { RatesModule } from "./modules/rates";
import { RegistrationsModule } from "./modules/registrations";
import { ParametersModule } from "./modules/parameters";
import { ProjectsModule } from "./modules/projects";
import { ReportsModule } from "./modules/reports";
import { RightsModule } from "./modules/rights";
import { SpecialtiesModule } from "./modules/specialties";
import { SecurityRolesModule } from "./modules/usersSecurityRoles";
import history from './store/history'
import { ConnectedRouter } from "connected-react-router";

import { loadModules } from "./store/loadModule";
import { PermissionsModule } from "./modules/permission";
import { UsersModule } from "./modules/users";


import { CssBaseline } from "@mui/material";
import ThemeCustomization from "./themes";
import SnackbarProviderExtended from "./components/mui/messages/snackbarProviderExtended/snackbarProviderExtended";

import Main from "./pages/main/main";
import './App.css';

export const ENABLED_MODULES = loadModules([PermissionsModule, UsersModule, RightsModule, SecurityRolesModule, ParametersModule,ProjectsModule,RegistrationsModule,ReportsModule,SpecialtiesModule,RatesModule])
export const ROUTES = ENABLED_MODULES.loadRoutes()

function App() {
	return (
		<ThemeCustomization>
			<SnackbarProviderExtended>
					<ConnectedRouter history={history}>
						<CssBaseline/>
						<Main/>
					</ConnectedRouter>
			</SnackbarProviderExtended>
		</ThemeCustomization>
	);
}

export default App;
